import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
} from "@mui/material"
import { ExpandMore as ExpandMoreIcon } from "@mui/icons-material"

const GLOSSARY_ITEMS = [
  {
    title: "DAU — Daily Active Users",
    body: "Среднее количество уникальных авторов, написавших хотя бы одно сообщение за день. Это базовый показатель ежедневной активности. Для рекламодателя означает: столько людей увидит ваш пост в первые 24 часа (при размещении в день пика). Норма для живого TG-чата: ≥10. Маленький чат: 5–30. Крупный: 100+.",
  },
  {
    title: "WAU — Weekly Active Users",
    body: "Среднее количество уникальных авторов за неделю. Более стабильный показатель, чем DAU — сглаживает всплески и провалы. Показывает недельную «разогретую» аудиторию чата. Ориентир: WAU должен быть в 2–4 раза больше DAU.",
  },
  {
    title: "MAU — Monthly Active Users",
    body: "Среднее количество уникальных авторов за месяц. Используется как знаменатель для Stickiness. Отражает «полную» аудиторию — тех, кто хотя бы раз что-то написал за месяц. Важно: это АВТОРЫ (кто пишет), а не просто читатели чата.",
  },
  {
    title: "Stickiness (DAU / MAU × 100%)",
    body: "Показывает, какой процент месячной аудитории возвращается КАЖДЫЙ ДЕНЬ. Чем выше — тем более «залипательным» является чат. Facebook/Instagram: 50–60%. Telegram-чаты: норма 10–35%. Ниже 5% — аудитория заходит редко, ваш рекламный пост быстро утонет в ленте.",
  },
  {
    title: "Fraud Score",
    body: "Комплексный показатель риска накрутки аудитории. Рассчитывается по 9 эвристикам: доля ботов, «одноразовые» авторы, концентрация у топ-1, уровень реакций, stickiness, ночная активность, дубликаты сообщений, активность лидера, равномерность распределения. 0–20: чат органичный. 20–40: есть вопросы. 40–65: высокий риск. 65+: вероятная накрутка.",
  },
  {
    title: "Доля ботов",
    body: "Процент сообщений, написанных ботами или от лица канала (channel*). Боты — не всегда плохо: часто это вспомогательные сервисы (Pipisa Bot, распознавание речи и т.п.). Плохо, если боты создают видимость активности вместо реальных людей. Норма: <10%. 10–30%: умеренно. >30%: повышенный риск.",
  },
  {
    title: "Реакции / сообщение (ER)",
    body: "Engagement Rate через реакции. Показывает, насколько аудитория вовлечена: ставит ли лайки, реагирует ли на контент. Низкий ER при большом числе сообщений — признак, что аудитория читает мало или чат накручен. >0.5 — отлично, 0.1–0.5 — норма, 0.05–0.1 — низко, <0.05 — очень плохо.",
  },
  {
    title: "Ответы (Reply Rate)",
    body: "Доля сообщений, являющихся ответом на предыдущее сообщение. Высокий reply rate — признак реальных диалогов между людьми. Если все просто пишут в общий поток без ответов — это похоже на флуд или рассылку. Норма: >20%. Отлично: >40%.",
  },
  {
    title: "Ночная активность (00:00–07:00)",
    body: "Доля сообщений в ночное время суток. Реальные люди ночью почти не пишут. Равномерная активность 24/7 — признак ботов. Паттерн живого чата: пик вечером, провал ночью. Норма: <15%. >25% — подозрительно.",
  },
  {
    title: "Дубликаты сообщений",
    body: "Процент сообщений с одинаковым текстом. Небольшое количество дублей нормально (приветствия, «ок», смайлы). Много дублей — признак массовых рассылок, копипасты или ботов, пишущих по шаблону. Норма: <10%. >20% — подозрительно.",
  },
  {
    title: "Одноразовые авторы",
    body: "Пользователи, написавшие ровно одно сообщение за весь период. Небольшая доля нормальна — люди заходят, задают вопрос и уходят. Но если >50% — это может быть накрутка: боты пишут по одному сообщению, чтобы не выглядеть подозрительно. Норма: <30%.",
  },
]

export function MetricsGlossary() {
  return (
    <>
      {GLOSSARY_ITEMS.map((item) => (
        <Accordion key={item.title} disableGutters sx={{ mb: 0.5 }}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography variant="body2" fontWeight={600} color="info">
              {item.title}
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography
              variant="body2"
              color="text.secondary"
              sx={{ lineHeight: 1.7 }}
            >
              {item.body}
            </Typography>
          </AccordionDetails>
        </Accordion>
      ))}
    </>
  )
}
